import React from "react";
import { GraduationCap } from "lucide-react";

const Header = ({ currentTermInfo }) => {
  return (
    <div className="bg-white border-b border-zinc-200 text-zinc-700 px-6 py-2 flex items-center justify-between text-xs font-medium shrink-0">
      <div className="flex items-center gap-3">
        <span className="bg-[#002855] text-white text-[10px] font-bold px-2 py-0.5 rounded tracking-wider uppercase">
          {currentTermInfo?.branchName || "Main Branch"}
        </span>
        <span className="text-zinc-300">|</span>
        <span className="text-zinc-900 font-semibold flex items-center gap-1.5">
          <GraduationCap className="w-4 h-4 text-zinc-700" />
          Teacher Classroom Portal
        </span>
        <span className="text-zinc-300">•</span>
        <span className="text-zinc-500">
          {currentTermInfo?.loading
            ? "Loading..."
            : currentTermInfo?.yearName && currentTermInfo?.termName
            ? `Academic Year ${currentTermInfo.yearName} (${currentTermInfo.termName})`
            : "Academic Term Not Set"}
        </span>
      </div>
    </div>
  );
};

export default Header;